var render, staticRenderFns
import script from "./FilledButton.vue?vue&type=script&lang=ts&"
export * from "./FilledButton.vue?vue&type=script&lang=ts&"
import style0 from "./FilledButton.vue?vue&type=style&index=0&id=35622cbb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35622cbb",
  null
  
)

export default component.exports